import { convertToSiteMonitoringMessage } from '../formatters/convertToSiteMonitoringMessage'
import type { ConsoleMessageData } from '../types'
import type { SiteMonitoringService } from './createSiteMonitoringService'

export const sendConsoleMessagesToSiteMonitoring =
	(siteMonitoringService: SiteMonitoringService) => async (consoleMessage: ConsoleMessageData) => {
		const message = convertToSiteMonitoringMessage(consoleMessage)

		if (message) {
			siteMonitoringService.send(message)
		}
	}
